import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type Props = {
  label: string
  isSelected: boolean
  onSelect?: () => void
  isSelectable: boolean
  size?: "small" | "medium"
  selectedClassName?: string
  unselectedClassName?: string
  leftIcon?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const BlockItemTag: React.FC<Props> = ({
  label,
  isSelected,
  onSelect,
  size = "medium",
  isSelectable,
  className,
  selectedClassName = "border-1 border-transparent bg-forestGreen-500",
  unselectedClassName = "border-1 border-neutral-400 bg-transparent",
  leftIcon,
  ...props
}) => {
  const theme = useTheme()

  return (
    <div
      className={`rounded-33 align-self-start
        ${isSelected ? selectedClassName : unselectedClassName} 
        ${size === "small" ? " px-2 pb-1 " : "py-2 px-3 "}
        ${isSelectable ? "cursor-pointer hover:border-500 transition-duration-300 transition-all " : ""}
        ${!isSelected && isSelectable ? "hover:surface-300 " : ""}
        ${className}
      `}
      onClick={onSelect}
      {...props}
    >
      {leftIcon}
      <HUText fontStyle={size === "small" ? "LS" : "LM"} color={isSelected ? theme.mainWhite : theme.textPrimary}>
        {label}
      </HUText>
    </div>
  )
}
